import React, {Component} from 'react';

import moment from 'moment';
import swal from 'sweetalert2';

import urls from "../../../utils/urls";
import {apiToken, tokenHeader} from "../../../utils/headers";
import {Spinner} from '../../../components/Loading/Spinner';
import Datepicker from "../../../components/Datepicker/datepicker";
import helpers from "../../../utils/helpers";
import axios from "axios/index";
import {ajaxHandler} from "../../../utils/errors";

export default class ReportReception extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ajaxInProgress: false,
            products: false,
            terminals: false,
            type: 'reception',
            unload_finished_at_gte: '',
            unload_finished_at_lte: '',
            product: '',
            terminal: ''
        }
    }

    componentDidMount(){
        this._fetchOptions();
    }

    _initializeHTML(){
        window.initializeSelects('.filter');
        window.bindSelectAction(this.productSelect, this._handleSelectChange);
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
    }

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    _fetchOptions = () => {

        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        axios.all([
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
        ])
            .then(axios.spread(function (terminal, prod) {
                return {
                    terminals: terminal,
                    products: prod
                }
            }))
            .then((data) => {
                this.setState({
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === helpers.trip_type.FE)
                }, this._initializeHTML)
            })
            .catch(ajaxHandler)
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value});
    };

    _emptyFilters = () => {
        this.setState({
            unload_finished_at_gte: '',
            unload_finished_at_lte: '',
            product: '',
            terminal: ''
        }, () => {
            window.reInitializeSelects('.filter');
        });
    };

    _generateReport = () => {

        let {type, unload_finished_at_gte, unload_finished_at_lte, product, terminal} = this.state;

        if(unload_finished_at_gte && unload_finished_at_lte && unload_finished_at_gte >= unload_finished_at_lte){

            swal({
                title: 'Filtros inválidos',
                html: 'Por favor ingrese un período válido de filtro para generar su reporte',
                type: 'error'
            });

            return false;
        }
        this.setState({ajaxInProgress: true});

        let REPORT_URL = `${urls.API_ROOT}/api/v1/reports/?type=${type}`;
        if(unload_finished_at_gte) REPORT_URL += `&unload_finished_at_gte=${unload_finished_at_gte}`;
        if(unload_finished_at_lte) REPORT_URL += `&unload_finished_at_lte=${unload_finished_at_lte}`;
        if(product) REPORT_URL += `&product=${product}`;
        if(terminal) REPORT_URL += `&terminal=${terminal}`;

        try{
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                let a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    this._onSubmitSuccess();
                    let filename = `Reporte de recepción - ${moment().format('DD-MM-YYYY')}.xlsx`;

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        //IE 10+
                        window.navigator.msSaveBlob(xhttp.response, filename);
                    }else {
                        // Trick for making downloadable link
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);
                        // Give filename you wish to download
                        a.download = filename;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }
                }else if(xhttp.status >= 300){
                    this._onSubmitError();
                }
            }.bind(this);
            // Post data to URL which handles post request
            xhttp.open("GET", REPORT_URL);
            xhttp.setRequestHeader("Authorization", `Token ${apiToken()}`);
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send();
        }
        catch(e){
            console.log(e);
        }

    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});
        swal({
            title: 'Reporte creado',
            html: 'El reporte ha sido creado correctamente. Espere unos segundos mientras se descarga',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });
    };

    _onSubmitError = () => {
        this.setState({ajaxInProgress: false});
        swal({
            title: 'No se ha podido crear el reporte',
            html: 'Por favor, vuelva a intentarlo nuevamente',
            type: 'error'
        });
    };


    render() {

        let {unload_finished_at_gte, unload_finished_at_lte, ajaxInProgress} = this.state;

        let buttonDisabled = (ajaxInProgress);

        let today = moment().startOf('month').format('YYYY-MM-DD');

        return (
            <div>
                <div className={'filter'}>
                    <div className={'row thin-row'}>
                        <div className={'col s3 input-field'}>
                            <select defaultValue={this.state.product} data-state-var="product"
                                    ref={ref => { this.productSelect = ref }}>
                                <option value="">Todos</option>
                                {this.state.products && this.state.products.map(product => {
                                    return <option key={product.id} id={product.id}
                                                   value={product.id}>{product.name}</option>
                                })}
                            </select>
                            <label>Producto</label>
                        </div>
                        <div className={'col s3 input-field'}>
                            <select defaultValue={this.state.terminal} data-state-var="terminal"
                                    ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Todos</option>
                                {this.state.terminals && this.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                            <label>Destino</label>
                        </div>
                        <div className={'col s3 m3 input-field'}>
                            <Datepicker value={unload_finished_at_gte} format={"YYYY-MM-DD"}
                                        openAction={() => {
                                            if(!unload_finished_at_gte) this.setState({unload_finished_at_gte: today});
                                        }}
                                        pickerFormat={"mm/yyyy"} momentFormat={"MM/YYYY"} hideDays={true}
                                        id="unload_finished_at_gte" action={this._handleDateChange}
                                        classname="" style={{position: 'relative'}}/>
                            <label className={"active"}>Fecha de descarga</label>
                        </div>
                        <div className={'col s3 m3 input-field'}>
                            <div style={{position: 'absolute', left: 0, top: 13}}>
                                <p style={{position: 'absolute'}}>a</p>
                            </div>
                            <Datepicker value={unload_finished_at_lte} format={"YYYY-MM-DD"}
                                        openAction={() => {
                                            if(!unload_finished_at_lte) this.setState({unload_finished_at_lte: today});
                                        }}
                                        pickerFormat={"mm/yyyy"} momentFormat={"MM/YYYY"} hideDays={true}
                                        id="unload_finished_at_lte" action={this._handleDateChange}
                                        classname="" style={{position: 'relative', marginLeft: 10}}/>
                            <label className={"active"} />
                        </div>
                    </div>
                    <div className={"row text-right thin-row"}>
                        <div className={"col s12"}>
                            <div onClick={this._emptyFilters} className={"pointer"} style={{
                                color: "#000000",
                                fontWeight: 'bold'
                            }}>
                                Borrar filtros
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"text-right"}>
                    <button onClick={this._generateReport}
                            className={`no-margin btn btn-shell-empty z-depth-0 ${buttonDisabled ? 'disabled' : ''}`}>
                        Generar Reporte
                    </button>
                </div>
                {ajaxInProgress &&
                <div className={"text-center"}><Spinner/></div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Reports/ReportReception.js